import BlockModal from "@/components/BlockModal";
import ConfirmModal from "@/components/ConfirmModal";
import { ButtonSection } from "@/components/Customer/ButtonSection";
import SubHeader from "@/components/SubHeader";
import { DrmPfPage } from "@/config";
import { CurrentTab } from "@/containers/customer/drmPf/useDrmPf";
import { useBlockerStore } from "@/stores/blocker";
import { useCustomerStore } from "@/stores/customer";
import { useProjectStore } from "@/stores/project";
import { useEffect, useMemo, useState } from "react";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

export default function DrmPf() {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const [
    selectedProject,
    selectedProjectCategory,
  ] = useProjectStore(state => [
    state.project,
    state.projectCategory,
  ]);

  const breadCrumbs = useMemo(() => {
    {
      switch (CurrentTab(pathname)) {
        case DrmPfPage.Detail:
          return [
            { title: selectedProject?.name },
            { title: selectedProjectCategory?.name, path: "/customer" },
            { title: "DRM-PF基本情報" },
          ];
        case DrmPfPage.Edit:
          return [
            { title: selectedProject?.name },
            { title: selectedProjectCategory?.name, path: "/customer" },
            {
              title: "DRM-PF基本情報",
              path: `/customer/drmpf/detail/${customerId}`,
            },
            { title: "編集" },
          ];
        default:
          return [
            { title: selectedProject?.name },
            { title: selectedProjectCategory?.name, path: "/customer" },
            { title: "資料ダウンロード" },
          ];
      }
    }
  }, [pathname, customerId, selectedProject, selectedProjectCategory]);

  const [isShowBackModal, setIsShowBackModal] = useState(false);

  const [drmPfCommonState, childSubmit] = useCustomerStore((state) => [
    state.drmPfCommonState,
    state.childSubmit,
  ]);
  const setBlocker = useBlockerStore((state) => state.setBlocker);

  const isEdit = CurrentTab(pathname) === DrmPfPage.Edit;
  const isApi = CurrentTab(pathname) === DrmPfPage.Api;
  const isDownload = CurrentTab(pathname) === DrmPfPage.Download;

  const handleTabChange = (tab: string) => {
    navigate(`/customer/drmpf/${tab}/${customerId}`);
  };

  const onClickCancel = () => {
    setBlocker(false);
    setIsShowBackModal(true);
  };
  const onClickSave = () => {
    setBlocker(false);
    childSubmit();
  };

  useEffect(() => {
    setBlocker(isEdit);
  }, [pathname]);

  const dispName = drmPfCommonState?.customerNumber + ' ' + drmPfCommonState?.groupName
    + (drmPfCommonState?.stationName !== '' && drmPfCommonState?.stationName !== null ? ' ' + drmPfCommonState?.stationName : '')
    + (drmPfCommonState?.departmentName !== '' && drmPfCommonState?.departmentName !== null ? ' ' + drmPfCommonState?.departmentName : '')
    + (drmPfCommonState?.sectionName !== '' && drmPfCommonState?.sectionName !== null ? ' ' + drmPfCommonState?.sectionName : '')
    + (drmPfCommonState?.unit_name !== '' && drmPfCommonState?.unit_name !== null ? ' ' + drmPfCommonState?.unit_name : '');

  return (
    <div>
      <div className="sub-header">
        <SubHeader
          breadCrumbs={breadCrumbs}
          title={`${dispName}`}
        />
        <ul className="uk-tab uk-margin-small-top">
          <li>
            <Link to={`/customer/drmpf/api/${customerId}`}>利用料</Link>
          </li>
          <li>
            <Link to={`/customer/basicinfo/detail/${customerId}`}>
              基本情報
            </Link>
          </li>
          <li className="uk-active">
            <Link to={`/customer/drmpf/detail/${customerId}`}>DRM-PF</Link>
          </li>
          <li>
            <Link to={`/customer/ticket/${customerId}`}>DRM-Chat</Link>
          </li>
          <div className="right">
            最終更新：{drmPfCommonState?.modified_by}&emsp;日時：
            {drmPfCommonState?.modified}
          </div>
        </ul>
      </div>
      <div className="container">
        <ul className="uk-tab customer-attribute-tab">
          <li
            className={!isApi && !isDownload ? "uk-active" : ""}
            onClick={() => handleTabChange(DrmPfPage.Detail)}
          >
            <a className="leading-1">
              DRM-PF
              <br />
              基本情報
            </a>
          </li>
          <li
            className={isDownload ? "uk-active" : ""}
            onClick={() => handleTabChange(DrmPfPage.Download)}
          >
            <a className="h-75">資料ダウンロード</a>
          </li>
          <ButtonSection
            handleTabChange={handleTabChange}
            onClickCancel={onClickCancel}
            onClickSave={onClickSave}
          />
        </ul>
        <Outlet />
      </div>
      <BlockModal />
      <ConfirmModal
        text="登録をキャンセルしますか？入力したデータは登録されません。"
        confirmButtonText="前の画面へ"
        isShow={isShowBackModal}
        onConfirm={() => {
          setIsShowBackModal(false);
          navigate(-1);
        }}
        onCancel={() => {
          setIsShowBackModal(false);
        }}
      />
    </div>
  );
}
export const drm_pf_info_items = [{ label: "承認状況", content: "未承認" }];
